import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioUnselected = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 1.5,
		width: 17,
		height: 17,
		rx: 4.5,
		fill: "var(--color-white)",
		stroke: "currentColor"
	})
});
export default SvgRadioUnselected;
